import { Link } from '@tanstack/react-router'
import { Card } from '@/components/ui/card'
import AuthLayout from '../auth-layout'
import { OtpForm } from './components/otp-form'

export default function Otp() {
  return (
    <AuthLayout>
      <Card className='p-6'>
        <div className='mb-2 flex flex-col space-y-2 text-left'>
          <h1 className='text-md font-semibold tracking-tight'>
            İki faktörlü doğrulama
          </h1>
          <p className='text-sm text-muted-foreground'>
            Lütfen doğrulama kodunu girin. <br /> E-posta adresinize bir doğrulama kodu gönderdik.
          </p>
        </div>
        <OtpForm />
        <p className='mt-4 px-8 text-center text-sm text-muted-foreground'>
          Almadınız mı?{' '}
          <Link
            to='/giris-yap'
            className='underline underline-offset-4 hover:text-primary'
          >
            Yeni bir kod gönder.
          </Link>
          .
        </p>
      </Card>
    </AuthLayout>
  )
}
